import Vue from 'vue';
import Vuetify from 'vuetify';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        // DS Primary/600 — checkboxes, ripples, and `color="primary"` controls
        primary: '#A94FD2',
      },
    },
  },
  breakpoint: {
    thresholds: {
      xs: 0,
      sm: 400,
      md: 768,
      lg: 1280,
    },
    scrollBarWidth: 0,
    mobileBreakpoint: 'sm',
  },
});
